// extracted by mini-css-extract-plugin
module.exports = {"buttons":"PaymentButton_buttons__28goM","button":"PaymentButton_button__x3JQU","disabled":"PaymentButton_disabled___B9xY"};